import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
import { Ornament } from './Ornament';
import { EVENT, MAPS_URL } from '../data/invitation';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="relative flex min-h-[100svh] w-full flex-col overflow-hidden bg-paper-100 px-6 pb-16 pt-10 sm:px-10 lg:px-16" data-id="element-17" data-mp="9ipcvdlvdi16">
      <div aria-hidden="true" className="paper-grain pointer-events-none absolute inset-0 opacity-60" data-id="element-18" data-mp="12a0mpfljy8wq" />

      <motion.span aria-hidden="true" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.3,
      delay: 0.4,
      ease
    }} className="pointer-events-none absolute -right-10 top-1/2 -translate-y-1/2 select-none font-serif text-[42vw] font-light leading-none text-ink-900/[0.04] lg:-right-16 lg:text-[30vw]" data-id="element-19" data-mp="x9un9d91ji43">
        40
      </motion.span>

      <div className="relative flex items-center justify-between border-b border-ink-900/10 pb-5 text-[0.65rem] uppercase tracking-label text-ink-500" data-id="element-20" data-mp="3825zouknofnh">
        <span data-id="element-21" data-mp="3j6fwnlhhz5bq">Vabilo</span>
        <span data-id="element-22" data-mp="3o7c1q2dl4xiq">{EVENT.dateShort}</span>
      </div>

      <div className="relative mx-auto flex w-full max-w-5xl flex-1 flex-col justify-center py-16" data-id="element-23" data-mp="3o73no75q7m5y">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} className="font-serif text-[clamp(3.5rem,13vw,10rem)] font-light leading-[0.9] tracking-tight text-ink-900" data-id="element-24" data-mp="399tdd14tkmbt">
          40. poglavje
        </motion.h1>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease
      }} className="mt-8" data-id="element-25" data-mp="35audhuxy3fr8">
          <Ornament align="left" data-id="element-26" data-mp="2vj7sj6vt22ba" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease
      }} className="mt-8 max-w-2xl font-serif text-xl font-light italic leading-snug text-accent-500 sm:text-2xl lg:text-3xl" data-id="element-27" data-mp="2hix03zeukfo0">
          Urednik je očitno zavrnil mojo prošnjo za podaljšanje prejšnjega.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease
      }} className="dropcap mt-8 max-w-xl font-serif text-lg leading-relaxed text-ink-700 sm:text-xl sm:leading-relaxed" data-id="element-28" data-mp="ibp02q9eowx0">
          Kljub mojemu upiranju je torej napočil čas za novo poglavje. Ker se številki 40 očitno ne
          morem več izogniti, jo bomo vsaj primerno proslavili.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.24,
        ease
      }} className="mt-14 flex flex-col gap-10 border-t border-ink-900/10 pt-10 lg:flex-row lg:items-end lg:justify-between" data-id="element-29" data-mp="x14mxv5tgi7f">
          <dl className="grid gap-8 sm:grid-cols-3 sm:gap-12" data-id="element-30" data-mp="1x9b6134gx5dm">
            <div data-id="element-31" data-mp="1xb5pse406rg4">
              <dt className="text-[0.65rem] uppercase tracking-label text-ink-400" data-id="element-32" data-mp="1x7hupaiwtwza">Kdaj</dt>
              <dd className="mt-2 font-serif text-2xl font-light text-ink-900 sm:text-[1.75rem]" data-id="element-33" data-mp="218tprvkjzaev">
                {EVENT.dateLong}
              </dd>
              <p className="mt-1 text-sm text-ink-500" data-id="element-34" data-mp="2b0zdgt3rv5o9">od 14.00 dalje</p>
            </div>

            <div data-id="element-35" data-mp="2g0c1hh6dqisf">
              <dt className="text-[0.65rem] uppercase tracking-label text-ink-400" data-id="element-36" data-mp="2fyr83uvsx5w5">Kje</dt>
              <dd className="mt-2 font-serif text-2xl font-light text-ink-900 sm:text-[1.75rem]" data-id="element-37" data-mp="2ky40sw9ct76n">
                {EVENT.place}
              </dd>
              <p className="mt-1 text-sm text-ink-500" data-id="element-38" data-mp="2oye6e7t8hvkz">Slovenija</p>
            </div>

            <div data-id="element-39" data-mp="2tysgrwib5hm6">
              <dt className="text-[0.65rem] uppercase tracking-label text-ink-400" data-id="element-40" data-mp="2tx7lu5s2zwns">Naslov</dt>
              <dd className="mt-2" data-id="element-41" data-mp="uok9nc6w370z">
                <a href={MAPS_URL} target="_blank" rel="noreferrer" className="group inline-flex items-center gap-2 font-serif text-2xl font-light italic text-accent-500 underline decoration-accent-500/30 decoration-1 underline-offset-4 transition-colors duration-200 ease-chapter hover:text-ink-900 hover:decoration-ink-900/40 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-accent-500 sm:text-[1.75rem]" data-id="element-42" data-mp="zl104d1k9xh8">
                  {EVENT.addressLabel}
                  <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-200 ease-chapter group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-43" data-mp="3crftpwjuz8lm" />
                </a>
              </dd>
            </div>
          </dl>

          <a href="#prijava" className="shrink-0 rounded-sm bg-ink-900 px-8 py-4 text-center text-xs font-semibold uppercase tracking-[0.18em] text-paper-50 transition-colors duration-200 ease-chapter hover:bg-ink-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-accent-500" data-id="element-44" data-mp="2yz9au2pbmnih">
            Potrdi udeležbo
          </a>
        </motion.div>
      </div>
    </header>;
}